export default __webpack_public_path__ + "static/media/submenu_1_off.a57c851a.svg";